import { ImageAspectRatio } from "./image.types";

export function aspectRatioAttribute(
    aspectRatio: ImageAspectRatio | number | undefined,
): number | undefined {
    if (!aspectRatio) {
        return undefined;
    }

    if (typeof aspectRatio === "number") {
        return aspectRatio;
    }

    const [width, height] = aspectRatio.split("/", 2).map(Number);

    return width / height;
}

export function computeDimensions(
    width: number | undefined,
    height: number | undefined,
    aspectRatio: number | undefined,
): { width?: number; height?: number } {
    let computedWidth: number | undefined = width;
    let computedHeight: number | undefined = height;

    if (width && aspectRatio) {
        // If width and aspetRatio are both provided, that takes precedence over height
        computedHeight = width / aspectRatio;
    } else if (height && !width && aspectRatio) {
        // If height and aspectRatio are provided without width, compute width
        computedWidth = height * aspectRatio;
    }

    return {
        width: computedWidth,
        height: computedHeight,
    };
}
